import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.324 15.506l-3.525-5.09-.126-.183.126-.182 3.525-5.091-8.19-.008s0 0 0 0c-.43 0-.813.212-1.043.537h0l-3.365 4.744 3.365 4.743h0c.23.326.613.537 1.042.537 0 0 0 0 0 0l8.191-.007z" fill="#A87DF3" stroke="#fff" strokeWidth=".64" /></svg>);